import React, { useState, useEffect } from "react";
import Papa from "papaparse";
import Chart from "react-apexcharts";

const ApexChartComponent = () => {
  const [apexChartData, setApexChartData] = useState([]);

  useEffect(() => {
    Papa.parse("/output/elbow_data.csv", {
      download: true,
      header: true,
      complete: (result) => {
        if (result.data && result.data.length > 0) {
          const clustersData = result.data
            .map((row) => ({
              x: parseInt(row["Number of Clusters"], 10),
              y: parseFloat(row["WCSS"]),
            }))
            .filter((point) => !isNaN(point.x) && !isNaN(point.y)); // Remove NaN entries

          const xValues = clustersData.map((point) => point.x);
          const yValues = clustersData.map((point) => point.y);

          console.log("clustersData", yValues);

          setApexChartData({
            options: {
              chart: {
                id: "apexchart-example",
                toolbar: { show: false },
                title: {
                  text: "Cluster Consumption",
                  align: "center",
                  style: { fontSize: "18px" },
                },
              },
              title: {
                text: "Elbow Curve",
                align: "left",
              },
              xaxis: {
                title: {
                  text: "Number of Clusters",
                  style: {
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#000",
                    text: "center",
                  },
                },
                categories: xValues,
              },
              yaxis: {
                title: {
                  text: "WCSS",
                  style: {
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "#000",
                  },
                },
              },
              stroke: {
                curve: "smooth",
                width: 2,
              },
              markers: { size: 4, colors: ["#FF4560"] },
            },
            series: [{ name: "Cluster Data", data: yValues }],
          });
        }
      },
    });
  }, []);

  return (
    <div className="card-body">
      <div className="alert alert-success" role="alert">
        Optimal number of clusters: 10
      </div>
      <div className="container">
        <div className="row">
          {apexChartData.series &&
            apexChartData.series.map((series, index) => (
              <div key={index}>
                <Chart
                  options={apexChartData.options}
                  series={[series]}
                  type="line"
                  height={350}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ApexChartComponent;
